var logger = require('./logger');
var ls = require('./loggerSendQueue');
var loggerSendQueue = ls.loggerSendQueue;
var navigationTracker = require('./navigationTracker');

(function () {
    'use strict';

    /**
     * @ngInject
     */
    angular.module('portalApp')
    .config(['$provide', 'appConfig', 'tokenService', function ($provide, appConfig, tokenService) {

        $provide.decorator('$log', ['$delegate', function ($delegate) {

            logger($delegate, appConfig, tokenService);

            return $delegate;
        }]);
    }])
    .run(['$rootScope', 'appConfig', 'tokenService', function ($rootScope, appConfig, tokenService) {
        // Flush the shared buffer when the user closes or refreshes the browser tab.
        // sendBeacon is used because it survives tab close unlike async $.ajax.
        // Falls back to $.ajax flush for browsers that don't support sendBeacon.
        window.addEventListener('beforeunload', function () {
            var instance = loggerSendQueue.getInstance(appConfig, tokenService);
            var sessionToken = tokenService.getSessionToken();
            if (sessionToken && navigator.sendBeacon) {
                // sendBeacon is fire-and-survive: browser delivers it even after tab close.
                // Re-use the same queue drain logic by calling flush() first to build
                // queueSend, then post via sendBeacon.
                instance.flush();
            } else {
                instance.flush();
            }
        });

        // Track every page navigation: captures destination URL, source URL,
        // studyId and time spent on the previous page.
        // Events are pushed into the shared loggerSendQueue and batched with
        // regular app logs — one POST per 20 combined entries.
        $rootScope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
            // Skip same-URL events (hash-only changes, modal open/close, etc.)
            // to avoid cluttering Dynatrace with redundant PageView entries.
            if (newUrl === oldUrl) { return; }
            navigationTracker.track(oldUrl, newUrl, appConfig, tokenService);
        });
    }]);

})();
